var _excluded = ["heading", "isActive", "isMobileSectionSticky", "hideHeadingOnBiggerScreen", "color", "spacing", "id", "children", "backgroundImage", "hasSeparator", "hasOverflowHidden", "isFillingRemainingSpace", "otherSectionRefs", "htmlTagValue"];
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useEffect, useState } from "react";
import loadable from "@loadable/component";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
import useBreakpoint from "../../../hooks/useBreakpoint";
import useDeviceDetect from "../../../hooks/useDeviceDetect";
import { animationDuration } from "../../../settings";
import breakpoint from "../../../utils/breakpoint";
import getBorderColor from "../../../utils/getBorderColor";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import AccentHeadingAtm from "../../atoms/AccentHeadingAtm";
import ToggleHeadingAtm from "../../atoms/ToggleHeadingAtm";
import BreakpointVisibilityOrg from "../BreakpointVisibilityOrg";
import ContainerOrg from "../ContainerOrg";
import SectionOrg from "../SectionOrg";
var AnimateHeight = loadable(function () {
  return import("react-animate-height");
});
var mediumBreakpointScreen = "medium";
var triggerBackgroundColor = "backgroundLight";
var emphasis = "low";
var Trigger = styled.div.withConfig({
  componentId: "sc-o9dtrm-0"
})(function (_ref) {
  var theme = _ref.theme;
  return css(["display:flex;flex-direction:column;justify-content:center;height:", ";border-top:", " solid ", ";background:", ";cursor:pointer;"], space(8), unit(1), getBorderColor(theme, triggerBackgroundColor, emphasis), getColor(theme, triggerBackgroundColor));
});
var StyledAccentHeadingAtm = styled(AccentHeadingAtm).withConfig({
  componentId: "sc-o9dtrm-1"
})([":last-child{margin-bottom:", ";}"], space(4));
export var Content = styled.div.withConfig({
  componentId: "sc-o9dtrm-2"
})(function (_ref2) {
  var theme = _ref2.theme;
  return css(["", "{border-top:", " solid ", ";}"], breakpoint("small", mediumBreakpointScreen), unit(1), getBorderColor(theme, triggerBackgroundColor, emphasis));
});
function ToggleSectionContainerOrg(_ref3) {
  var heading = _ref3.heading,
    isActive = _ref3.isActive,
    isMobileSectionSticky = _ref3.isMobileSectionSticky,
    hideHeadingOnBiggerScreen = _ref3.hideHeadingOnBiggerScreen,
    color = _ref3.color,
    spacing = _ref3.spacing,
    id = _ref3.id,
    children = _ref3.children,
    backgroundImage = _ref3.backgroundImage,
    hasSeparator = _ref3.hasSeparator,
    hasOverflowHidden = _ref3.hasOverflowHidden,
    isFillingRemainingSpace = _ref3.isFillingRemainingSpace,
    otherSectionRefs = _ref3.otherSectionRefs,
    htmlTagValue = _ref3.htmlTagValue,
    restProps = _objectWithoutProperties(_ref3, _excluded);
  var isBiggerScreen = useBreakpoint(mediumBreakpointScreen);
  var _useDeviceDetect = useDeviceDetect(),
    isDesktop = _useDeviceDetect.isDesktop;
  var _useState = useState(isActive),
    _useState2 = _slicedToArray(_useState, 2),
    isActiveState = _useState2[0],
    setIsActiveState = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasHoverState = _useState4[0],
    setHasHoverState = _useState4[1];
  var sectionSpacing;
  if (isBiggerScreen) {
    sectionSpacing = spacing;
  } else if (isMobileSectionSticky) {
    sectionSpacing = "sticky";
  } else {
    sectionSpacing = "small";
  }
  var sectionHeight = isActiveState || isBiggerScreen ? "auto" : 0;
  var toggleAnimationDuration = !isBiggerScreen ? animationDuration.slow : 0;
  var handleClick = function handleClick() {
    return setIsActiveState(!isActiveState);
  };
  var handleMouseEnter = function handleMouseEnter() {
    if (isDesktop) {
      setHasHoverState(true);
    }
  };
  var handleMouseLeave = function handleMouseLeave() {
    if (isDesktop) {
      setHasHoverState(false);
    }
  };
  useEffect(function () {
    setIsActiveState(isActive);
  }, [setIsActiveState, isActive]);
  return /*#__PURE__*/React.createElement("div", restProps, /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "small",
    to: mediumBreakpointScreen
  }, /*#__PURE__*/React.createElement(Trigger, {
    onClick: handleClick,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, /*#__PURE__*/React.createElement(ContainerOrg, null, /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: triggerBackgroundColor
  }, /*#__PURE__*/React.createElement(ToggleHeadingAtm, {
    isActive: isActiveState,
    hasHoverState: hasHoverState,
    htmlTagValue: htmlTagValue
  }, heading))))), /*#__PURE__*/React.createElement(AnimateHeight, {
    height: sectionHeight,
    duration: toggleAnimationDuration
  }, /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(SectionOrg, {
    id: id,
    color: color,
    spacing: sectionSpacing,
    backgroundImage: backgroundImage,
    hasSeparator: hasSeparator,
    hasOverflowHidden: hasOverflowHidden,
    isFillingRemainingSpace: isFillingRemainingSpace,
    otherSectionRefs: otherSectionRefs
  }, /*#__PURE__*/React.createElement(ContainerOrg, null, !hideHeadingOnBiggerScreen && /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: mediumBreakpointScreen
  }, /*#__PURE__*/React.createElement(StyledAccentHeadingAtm, {
    htmlTagValue: htmlTagValue
  }, heading)), children)))));
}
export default ToggleSectionContainerOrg;